<div fxLayout="column" fxLayoutAlign="space-around stretch" class="no-scroll">
  <div fxLayout="row" fxLayoutAlign="center" class="dialog-title">
    <div fxFlex="15"></div>
    <h2 mat-dialog-title fxFlex="70">SUCURSAL</h2>
    <button
      mat-icon-button
      fxFlex="15"
      aria-label="close dialog"
      mat-dialog-close
      class="close-button"
      color="warn"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content fxLayout="row" fxLayoutAlign="center">
    <form
      name="form"
      *ngIf="form"
      [formGroup]="form"
      autocomplete="off">
      <div 
        fxLayout="column" 
        fxLayoutAlign="space-between center">
        <mat-form-field appearance="outline">
          <mat-label>Número Establecimiento</mat-label>
          <input 
            matInput 
            formControlName="establishmentNumber" 
          />
          <mat-icon
            matSuffix
            class="secondary-text"
            [matTooltip]="notification.establishmentNumber"
            [ngClass]="{ 'error-icon': controlHasError('establishmentNumber') }"
          >
            class
          </mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Ciudadela</mat-label>
          <input matInput formControlName="citadel" />
          <mat-icon
            matSuffix
            class="secondary-text"
            [matTooltip]="notification.citadel"
            [ngClass]="{ 'error-icon': controlHasError('citadel') }"
          >
            account_balance
          </mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Correo electrónico</mat-label>
          <mat-select 
            formControlName="isOwnDomain" 
            required
          >
            <mat-option value="true">Dominio propio</mat-option>
            <mat-option value="false">Dominio predefinido</mat-option>
          </mat-select>
          <mat-icon
            matSuffix
            class="secondary-text"
            [matTooltip]="notification.class"
            [ngClass]="{ 'error-icon': controlHasError('class') }"
          >
            mail_outline
          </mat-icon>
        </mat-form-field>
        <div *ngIf="this.form.get('isOwnDomain')?.value === 'false'">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input 
              matInput 
              formControlName="email" 
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.email"
              [ngClass]="{ 'error-icon': controlHasError('email') }"
            >
              email
            </mat-icon>
          </mat-form-field>
        </div>
        <div
          fxLayout="column"
          fxLayoutAlign="space-between center"
          *ngIf="this.form.get('isOwnDomain')?.value === 'true'"
        >
          <mat-form-field appearance="outline">
            <mat-label>Host</mat-label>
            <input
              matInput
              formControlName="host"
              minlength="7"
              maxlength="15"
              size="15"
              IPOnly
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.host"
              [ngClass]="{ 'error-icon': controlHasError('host') }"
            >
              desktop_windows
            </mat-icon>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Port</mat-label>
            <input matInput formControlName="port" maxlength="5" numbersOnly />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.port"
              [ngClass]="{ 'error-icon': controlHasError('port') }"
            >
              device_hub
            </mat-icon>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>User</mat-label>
            <input matInput formControlName="user" />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.user"
              [ngClass]="{ 'error-icon': controlHasError('user') }"
            >
              person
            </mat-icon>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input
              matInput
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="none"
              formControlName="password"
            />
            <button
              matSuffix
              mat-icon-button
              aria-label="mostrar"
              type="button"
              [matTooltip]="notification.password"
              [ngClass]="{ 'error-icon': controlHasError('password') }"
              (click)="showPassword = !showPassword"
            >
              <mat-icon matSuffix class="secondary-text">
                remove_red_eye
              </mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>From</mat-label>
            <input matInput formControlName="from" />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.from"
              [ngClass]="{ 'error-icon': controlHasError('from') }"
            >
              email
            </mat-icon>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="center">
    <button
      mat-raised-button
      (click)="submit()"
      [disabled]="isInvalidForm() || isLoading"
      color="primary"
      class="submit-button w-button"
    >
      <div class="loadingComponent" *ngIf="isLoading">
        <app-loading [isLoading]="isLoading" />
      </div>

      <span *ngIf="!isLoading">{{ txtBtn }}</span>
    </button>
  </mat-dialog-actions>
</div>
